import React from "react";
import { Link } from "react-router-dom";

const LOCATIONS = [
  {
    key: "rochester",
    name: "Rochester Rd. Shop — NEW",
    address: "7279 Rochester Rd, Lockport, NY 14094",
    phone: "(716) 438-7183",
    hours: ["Mon–Thu: 10:30 AM – 9:00 PM", "Fri–Sat: 10:30 AM – 10:00 PM", "Sun: 11:00 AM – 8:00 PM"],
    image: "/images/dinein.jpg",
    map: "https://maps.google.com/maps?q=7279+Rochester+Rd+Lockport+NY+14094&output=embed",
  },
  {
    key: "locust",
    name: "Locust St. Shop — Original",
    address: "Locust Street, Lockport, NY",
    phone: "(716) 433-0011",
    hours: ["Mon–Thu: 10:30 AM – 9:00 PM", "Fri–Sat: 10:30 AM – 10:00 PM", "Sun: 11:00 AM – 8:00 PM"],
    image: "/images/takeout.jpg",
    map: "https://maps.google.com/maps?q=Locust+St+Lockport+NY&output=embed",
  },
];

export default function Locations() {
  return (
    <div data-testid="locations-page">
      <section className="sd-page-hero">
        <h1>Our Locations</h1>
        <p className="text-white/90 mt-3">Two Lockport shops — same family, same recipes.</p>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12">
          {LOCATIONS.map((loc) => (
            <div
              key={loc.key}
              className="rounded shadow-lg overflow-hidden bg-white"
              data-testid={`location-card-${loc.key}`}
            >
              <iframe
                title={loc.name}
                src={loc.map}
                className="w-full h-72 border-0"
                loading="lazy"
              />
              <div className="p-6">
                <h2 className="text-2xl text-[#cd0202] font-display mb-3">{loc.name}</h2>
                <p className="text-gray-700 mb-1">{loc.address}</p>
                <p className="text-gray-700 mb-4">
                  <a href={`tel:${loc.phone}`} className="text-[#cd0202] font-semibold">
                    {loc.phone}
                  </a>
                </p>
                <div className="mb-4">
                  <p className="font-display text-gray-800 mb-1">Hours</p>
                  <ul className="text-gray-600 text-sm space-y-1">
                    {loc.hours.map((h) => <li key={h}>{h}</li>)}
                  </ul>
                </div>
                <Link
                  to={`/order?location=${loc.key}`}
                  className="sd-btn-red"
                  data-testid={`order-at-${loc.key}`}
                >
                  Order at this shop
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
